// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"bb339d65","251":"866e225e"}[chunkId] + ".chunk.js";
};